import { render, staticRenderFns } from "./GarantiaCard.vue?vue&type=template&id=7f876edf&"
import script from "./GarantiaCard.vue?vue&type=script&lang=js&"
export * from "./GarantiaCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports